/**
 * THE VIP 1:1 session. One product, sold two ways:
 *   - on its own at /vip-session (pick an instructor, pay, done)
 *   - as the "Go VIP" add-on on a workshop ticket (workshop-ticket-block.tsx
 *     on the page, server/routes.ts at checkout)
 * Both read the price and length from here so they cannot drift apart.
 * (Esther, 2026-10-13: $999, 90 minutes, any instructor.)
 */
export const VIP_SESSION = {
  priceCents: 99_900,
  minutes: 90,
  name: "VIP 1:1 Session",
  description: "90-minute private 1-on-1 session with an AdVenture instructor.",
} as const;

export function vipPriceLabel(): string {
  return `$${(VIP_SESSION.priceCents / 100).toLocaleString("en-US")}`;
}

/** coupon_codes.series_slug that marks a code as valid for the VIP session. */
export const VIP_COUPON_SCOPE = "vip-session";
